import { notifications } from "@mantine/notifications";

export const errorNotification = ({ title, message }: { title: string; message: string; }) => {
  notifications.show({
    title,
    message,
    color: "#AF4F4D",
    position: "top-right",
  });
};
